<template>
  <div class="contaier">
    <div class="max-box">
      <!-- <img
        alt=""
        v-if="showQR > -1"
        loading="lazy"
        class="qc-code"
        :src="QR_codeSrc"
        :style="{ left: `${showQR * 50}px` }"
      /> -->
      <!-- @mouseleave="handleMouseLeave" -->
      <!-- @mouseenter="handleMouseEnter(index)" -->
      <div class="contact-box">
        <div class="icon-box">
          <!-- <div
            :key="index"
            class="icon"
            @click="goNewPage1(itme.url)"
            v-for="(itme, index) in iconList"
          >
            <img alt="" loading="lazy" class="img" :src="itme.img" />
          </div> -->
          <ol class="tnc-wrapper-right flex text-sm-3 mdd:text-xl">
          <li class="pr-6 sm:pr-4 mdd:pr-8"><a class="iconfont_" href="https://www.instagram.com/icaurhk"
              target="_blank" title="iCAURHongKong on Instagram">&#xe612;</a></li>
          <li class="pr-6 sm:pr-4 mdd:pr-8"><a class="iconfont_ " href="https://www.facebook.com/iCAURHK"
              target="_blank" title="iCAURHongKong on Facebook">&#xe602;</a></li>
          <!-- <li class="pr-6 sm:pr-4 mdd:pr-8"><a class="iconfont_" href="https://www.linkedin.com/company/zeekrhk"
              target="_blank" title="iCAURHongKong on Linkedin">&#xe6c1;</a></li> -->
          <li class="pr-6 sm:pr-4 mdd:pr-8"><a class="iconfont_" href="https://www.youtube.com/@iCaurHK"
              target="_blank" title="iCAURHongKong on YouTube">&#xe7af;</a></li>
        </ol>
        </div>
        <div class="privacy-box">
          <a href="https://www.kamlung.com/copy-of-privacy-policy?lang=tc" target="_blank">收集個人資料聲明</a>
          <a href="https://www.kamlung.com/privacy-policy?lang=tc" target="_blank">私隱政策聲明</a>
        </div>
      </div>
      <div class="showroom-box">
        <div class="showroom-col showroom-left">
          <div class="showroom-group">
            <div class="showroom-title">旗艦陳列室</div>
            <div class="showroom-item">九龍灣宏冠道 6 號鴻力工業中心地下B11-12號舖</div>
          </div>
          <div class="showroom-group">
            <div class="showroom-title">期間限定陳列室</div>
            <div class="showroom-item">元朗青山公路屏山段 (塘坊村輕鐵站對面)</div>
            <div class="showroom-item">灣仔告士打道 39 號夏愨大廈地下 A 鋪</div>
          </div>
        </div>
        <div class="showroom-col showroom-right">
          <div class="showroom-group">
            <div class="showroom-title">售後服務中心</div>
            <div class="showroom-item">荃灣柴灣角街41-53號地下 <a href="tel:21194808" class="tel-link"><strong>Tel: 2119 4808</strong></a> </div>
            <!-- <div class="showroom-item">柴灣豐業街5號華盛中心地下 <a href="tel:21194828" class="tel-link"><strong>Tel: 2119 4828</strong></a></div>
            <div class="showroom-item">元朗青山公路屏山段 (塘坊村輕鐵站對面) <a href="tel:21194881" class="tel-link"><strong>Tel: 2119 4881</strong></a></div> -->
          </div>
        </div>
      </div>
        
      <div class="showroom-contact">
        <div class="showroom-title">銷售熱線: <a href="tel:85270728028" class="tel-link"><strong>7072 8028</strong></a> <a href="mailto:enquiry@icaurhk.com"><strong>enquiry@icaurhk.com</strong></a></div>
        <div class="showroom-title">電郵: <a href="mailto:enquiry@icaurhk.com"><strong>enquiry@icaurhk.com</strong></a></div>
      </div>
      <div class="sales-hotline">
        <div class="contact-title">Copyright ©2026 iCAUR Hong Kong All rights reserved</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterPage",
  data() {
    return {
      showQR: -1,
      // QR_codeSrc: "@/assets/img/footer/facebook-c.png",
      // iconList: [
      //   {
      //     id: 1,
      //     url: "https://www.facebook.com/",
      //     img: require("@/assets/img/footer/facebook.png"),
      //     // code: require("@/assets/img/footer/facebook-c.png"),
      //   },
      //   {
      //     id: 2,
      //     url: "https://www.instagram.com/",
      //     img: require("@/assets/img/footer/instagram.png"),
      //     // code: require("@/assets/img/footer/instagram-c.png"),
      //   },
      //   {
      //     id: 3,
      //     url: "https://www.whatsapp.com/?utm_source=chatgpt.com",
      //     img: require("@/assets/img/footer/whatsapp.png"),
      //     // code: require("@/assets/img/footer/whatsapp-c.png"),
      //   },
      // ],
    };
  },
  methods: {
    // handleMouseEnter(e) {
    //   this.showQR = e;
    //   this.QR_codeSrc = this.iconList[e].code;
    // },
    // handleMouseLeave() {
    //   this.showQR = -1;
    // },
    // goNewPage(p) {
    //   this.$router
    //     .push({ path: p, query: { lang: this.$i18n.locale } })
    //     .catch(() => {})
    // },
    goNewPage1(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
/* footer */
.iconfont_ {
  font-size: 32px;
}
.contaier {
  padding: 40px 0 30px;
  background-color: #000;
  color: #999;
  .max-box {
    padding: 0 20px;
    position: relative;

    .qc-code {
      width: 120px;
      height: 120px;
      position: absolute;
      top: 80px;
      // left: 30px;
      z-index: 999;
    }
  }
  .contact-title {
    font-size: 14px;
    // line-height: 4;
    // text-transform: uppercase;
    // font-weight: 700;
    // margin-top: 30px;
    // padding-top: 30px;
    letter-spacing: 0.1em;
    color: #898989;
  }
  .contact-box {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // max-width: 800px;
    .contact {
      color: #898989;
    }
    .icon-box {
      width: 300px;
      height: 100px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .privacy-box {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      a {
        color: #898989;
        margin-left: 1rem;
      }
    }
    a {
      transition: all 0.3s;
    }
    a:hover {
      color: #fff;
    }
    .icon {
      width: 40px;
      height: 40px;
      margin: 0 15px 0 0;
      cursor: pointer;
      filter: grayscale(100%);
      transition: all 0.3s;
      cursor: pointer;
      .img {
        width: 100%;
        height: 100%;
      }
    }
    .icon:hover {
      filter: grayscale(0);
      transition: all 0.3s;
    }
  }
  .sales-hotline {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    font-size: 14px;
    padding-top: 20px;
    border-top: solid 1px #333;
  }
  .showroom-box {
    padding: 20px 0 10px;
    font-size: 13px;
    line-height: 1.8;
    color: #898989;
    max-width: 800px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0;

    .showroom-col {
      flex: 1;
    }

    .showroom-group {
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .showroom-title {
      font-weight: 600;
      color: #bbb;
      margin-bottom: 4px;
    }
    .showroom-item {
      .tel-link {
        color: #bbb;
        text-decoration: none;
        margin-left: 8px;
        transition: color 0.3s;
        strong {
          font-weight: 700;
        }
        &:hover {
          color: #fff;
        }
      }
    }
  }
  .showroom-contact {
    padding: 10px 0 20px ;
    font-size: 13px;
    line-height: 1.8;
    color: #898989;
    max-width: 800px;
    display: flex;
    gap: 60px;

    .showroom-title {
      font-weight: 600;
      color: #bbb;
      margin-bottom: 4px;
    }
  }
}

@media (max-width: 768px) {
  .contaier {
    padding-bottom: 60px;
    .contact-box {
      .icon-box {
        padding-bottom: 15px;
        height: auto;
      }
      .privacy-box {
        a {
          font-size: 15px;
          margin-left: 0;
          margin-right: 1.2rem;
          padding-bottom: 20px;
        }
      }
    }
  }
  .contact-title {
    padding-top: 20px;
  }
  // 手机端单栏：售后地址接在銷售熱線下面
  .contaier .showroom-box {
    flex-direction: column;
    gap: 0;
  }
  
  .contaier .showroom-contact {
    flex-direction: column;
    gap: 0;

  }
}
@media (min-width: 768px) {
  .contaier {
    padding: 40px 20px 30px;
    .contact-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .nag-box {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .nag {
          // padding: 0 30px;
          // padding: 20px;
          line-height: 40px;
          font-size: 14px;
        }
        .nag:nth-child(n + 2) {
          padding-left: 20px;
        }
      }
    }
    .sales-hotline {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .contact-title {
        font-size: 13px;
      }
    }
  }
}
</style>
